import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "./PageHeader";
import axios from "axios";
import ReactPixel from "react-facebook-pixel";
import { getAnonUserId, getHostName } from "../helpers/utils";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useCartWishlist } from "../context/CartWishlistContext";

export default function ProductDetails() {
  const { slug } = useParams(); // slug from URL
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);


  const { 
      isInCart, addItemtoCart, removeItemtoCart,
      isInWishlist, addItemtoWishlist, removeItemtoWishlist,
      cartList
    } = useCartWishlist();

  const navigate = useNavigate();

  const [checkoutLoader, setCheckoutLoader] = useState(false);


  // const [wishList, setWishList] = React.useState([]);
  // const [cartList, setCartList] = React.useState([]);
  // const [wishListCounter, setWishListCounter] = React.useState(0);
  // const [cartListCounter, setCartListCounter] = React.useState(0);

  const hostname = getHostName();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const pid = localStorage.getItem("productId"); // get saved ID
        if (!pid) {
          console.error("No productId found in localStorage!");
          setLoading(false);
          return;
        }

        const res = await axios.post(`${hostname}/api/products/get-product`, {
          product_id: pid,
        });

        const p = res.data.product || res.data;
        setProduct(p);

        // Track product view (Meta Pixel)
        try {
          if (ReactPixel && typeof ReactPixel.track === "function") {
            ReactPixel.track("ViewContent", {
              content_ids: [p._id],
              content_name: p.title,
              content_type: "product",
              value: p.price,
              currency: "PKR",
            });
          }
        } catch (e) {
          console.warn("Pixel track error:", e);
        }
      } catch (err) {
        console.error("Error fetching product:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [hostname, slug]);

  // React.useEffect(() => {
  //   getAllCartListData();
  //   getAllWishListData();
  //   getCartCounterData();
  //   getWishlistCounterData();
  // }, []);

  // const getAllCartListData = () => {
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/cart/get`, {
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       let arr = [];
  //       arr = res.data.filter((v) => v.status);
  //       console.log(arr);

  //       setCartList(arr);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const getAllWishListData = () => {
  //   let anonUserId = getAnonUserId();
  //   if (anonUserId)
  //     axios
  //       .post(`${hostname}/api/wishlist/get-wishlist`, {
  //         annoUserDeviceId: anonUserId,
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         let arr = [];
  //         arr = res.data.filter((v) => v.status);
  //         console.log(arr);

  //         setWishList(arr);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  // };

  // const getCartCounterData = () => {
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .get(`${hostname}/api/cart/count?annoUserDeviceId=${anonUserId}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       setCartListCounter(res.data.count);
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const getWishlistCounterData = () => {
  //   let anonUserId = getAnonUserId();

  //   axios
  //     .get(
  //       `${hostname}/api/wishlist/get-wishlist-count?annoUserDeviceId=${anonUserId}`
  //     )
  //     .then((res) => {
  //       console.log(res.data);
  //       setWishListCounter(res.data.count);
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const addItemtoWishlist = (p_id) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();

  //   axios
  //     .post(`${hostname}/api/wishlist/add-in-wishlist`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setWishListCounter(wishListCounter + 1);
  //       getAllWishListData();

  //       toast.success("Product Added to Wishlist.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const removeItemtoWishlist = (p_id) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/wishlist/remove-from-wishlist`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setWishListCounter(wishListCounter - 1);

  //       getAllWishListData();

  //       toast.warning("Product removed to Wishlist.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const addItemtoCart = (p_id, quantity = 1) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/cart/add`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //       quantity,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setCartListCounter(cartListCounter + 1);
  //       getAllCartListData();

  //       toast.success("Product Added to Cart.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const removeItemtoCart = (p_id) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/cart/remove`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setCartListCounter(cartListCounter - 1);

  //       getAllCartListData();

  //       toast.warning("Product removed to cart.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const isProductInCart = () => {
  //   return cartList.some((v) => v.product._id === product._id);
  // };

  // const isProductInWishlist = () => {
  //   return wishList.some((v) => v.product._id === product._id);
  // };

  if (loading) {
    return (
      <section className="container py-5">
        <div className="text-center">Loading product...</div>
      </section>
    );
  }

  if (!product) {
    return (
      <section className="container py-5">
        <div className="text-center text-danger">Product not found.</div>
      </section>
    );
  }

  return (
    <>
      <PageHeader
        metaTitle={product.title}
        metaDescription={product.description
          .replace(/<[^>]+>/g, "")
          .slice(0, 160)}
        metaImage={product.imageUrl}
        metaType="product"
      />

      <section className="container py-5">
        <div className="row g-5">
          {/* Left: Images */}
          <div className="col-lg-6">
            <div className="card shadow-sm border-0 mb-3">
              <img
                src={product.imageUrl || "/img/placeholder.png"}
                alt={product.title}
                className="card-img-top rounded"
              />
            </div>
            {/* Thumbnails (if multiple images later) */}
            <div className="d-flex gap-2 flex-wrap">
              <img
                src={product.imageUrl}
                alt="thumb"
                className="border rounded"
                style={{ width: "70px", height: "70px", objectFit: "cover" }}
              />
            </div>
          </div>

          {/* Right: Info */}
          <div className="col-lg-6">
            <h2 className="fw-bold">{product.title}</h2>
            <p className="text-muted">Brand: {product.brand}</p>

            {/* Rating */}
            <div className="mb-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`bi ${
                    i < product.rating
                      ? "bi-star-fill text-warning"
                      : "bi-star text-warning"
                  }`}
                ></i>
              ))}
              <span className="ms-2 text-muted">{product.rating} / 5</span>
            </div>

            {/* Price */}
            <div className="mb-3">
              <h3 className="text-success mb-0">Rs. {product.price}</h3>
              {product.originalPrice && (
                <small className="text-muted text-decoration-line-through">
                  Rs. {product.originalPrice}
                </small>
              )}
            </div>

            {/* Availability */}
            <p>
              <span className="badge bg-success">In Stock</span> (
              {product.availableItems} items)
            </p>

            {/* Quantity Selector */}
            <div className="d-flex align-items-center mb-3">
              <button
                className="btn btn-outline-secondary"
                onClick={() => setQuantity((q) => Math.max(1, q - 1))}
              >
                -
              </button>
              <input
                type="text"
                readOnly
                className="form-control text-center mx-2"
                style={{ width: "60px" }}
                value={quantity}
              />
              <button
                className="btn btn-outline-secondary"
                onClick={() => setQuantity((q) => q + 1)}
              >
                +
              </button>
            </div>

            {/* Buttons */}
            <div className="mb-4">
              {/* Cart Button with Tooltip */}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-cart">
                    {isInCart(product._id) ? "Remove from Cart" : "Add to Cart"}
                  </Tooltip>
                }
              >
                <button
                  className="btn btn-warning me-2"
                  onClick={() =>
                    isInCart(product._id)
                      ? removeItemtoCart(product._id)
                      : addItemtoCart(product._id,quantity)
                  }
                >
                  {isInCart(product._id) ? (
                    <i className="bi bi-cart-fill text-success" />
                  ) : (
                    <i className="bi bi-cart" />
                  )}{" "}
                  Cart
                </button>
              </OverlayTrigger>

              

              {/* Wishlist Button with Tooltip */}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-wishlist">
                    {isInWishlist(product._id)
                      ? "Remove from Wishlist"
                      : "Add to Wishlist"}
                  </Tooltip>
                }
              >
                <button
                  className="btn btn-outline-danger"
                  onClick={() =>
                    isInWishlist(product._id)
                      ? removeItemtoWishlist(product._id)
                      : addItemtoWishlist(product._id)
                  }
                >
                  {isInWishlist(product._id) ? (
                    <i className="bi bi-heart-fill text-danger"></i>
                  ) : (
                    <i className="bi bi-heart"></i>
                  )}{" "}
                  Wishlist
                </button>
              </OverlayTrigger>

              {/* Proceed to Checkout button placed below Cart & Wishlist */}
              <div className="mt-3">
                <button
                  className="btn btn-success"
                  style={{ minWidth: "180px" }}
                  disabled={!cartList || cartList.length === 0 || checkoutLoader}
                  onClick={async () => {
                    try {
                      setCheckoutLoader(true);
                      // Track checkout CTA click
                      try {
                        if (ReactPixel && typeof ReactPixel.trackCustom === "function") {
                          ReactPixel.trackCustom("ClickedCheckoutBtn", {
                            product_id: product?._id,
                            value: product?.price,
                          });
                        }
                        if (ReactPixel && typeof ReactPixel.trackCustom === "function") {
                          const cartValue = (cartList || []).reduce((acc, item) => acc + (item.product?.price || 0) * (item.quantity || 0), 0);
                          ReactPixel.trackCustom("InitiateCheckout", {
                            itemsCount: cartList?.length || 0,
                            value: parseFloat(cartValue.toFixed(2)),
                            currency: "PKR",
                          });
                        }
                      } catch (e) {
                        console.warn("Pixel custom track error:", e);
                      }

                      const anonUserId = localStorage.getItem("anonUserId") || getAnonUserId();
                      await axios.post(`${hostname}/api/cart/bulk-update`, {
                        annoUserDeviceId: anonUserId,
                        items: cartList,
                      });
                      setTimeout(() => {
                        setCheckoutLoader(false);
                        navigate("/checkout");
                      }, 400);
                    } catch (err) {
                      console.error(err);
                      setCheckoutLoader(false);
                      if ("response" in err) toast.error(err.response.data.error, { theme: "colored" });
                      else toast.error("something went wrong!", { theme: "colored" });
                    }
                  }}
                >
                  {checkoutLoader ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    "Proceed to Checkout"
                  )}
                </button>
              </div>
            </div>

            {/* <div className="mb-4">
              <button
                className="btn btn-warning me-2"
                onClick={() =>
                  isProductInCart()
                    ? removeItemtoCart(product._id)
                    : addItemtoCart(product._id)
                }
              >
                {isProductInCart() ? (
                  <i className="bi bi-cart-fill text-success" />
                ) : (
                  <i className="bi bi-cart" />
                )}{" "}
                Add to Cart
              </button>
              <button
                className="btn btn-outline-danger"
                onClick={() =>
                  isProductInWishlist()
                    ? removeItemtoWishlist(product._id)
                    : addItemtoWishlist(product._id)
                }
              >
                {isProductInWishlist() ? (
                  <i className="bi bi-heart-fill text-danger"></i>
                ) : (
                  <i className="bi bi-heart"></i>
                )}{" "}
                Wishlist
              </button>
            </div> */}

            {/* Badges */}
            <div className="d-flex gap-2 flex-wrap">
              {product.isNewItem && (
                <span className="badge bg-info">New Arrival</span>
              )}
              {product.packSize && (
                <span className="badge bg-secondary">
                  Pack of {product.packSize}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="row mt-5">
          <div className="col-12">
            <ul className="nav nav-tabs" id="productTabs" role="tablist">
              <li className="nav-item">
                <button
                  className="nav-link active"
                  id="desc-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#desc"
                  type="button"
                  role="tab"
                >
                  Product Description
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  id="shipping-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#shipping"
                  type="button"
                  role="tab"
                >
                  Shipping & Return
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  id="delivery-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#delivery"
                  type="button"
                  role="tab"
                >
                  Delivery
                </button>
              </li>
            </ul>
            <div className="tab-content border p-4 bg-white rounded-bottom shadow-sm">
              <div
                className="tab-pane fade show active"
                id="desc"
                role="tabpanel"
              >
                <div
                  dangerouslySetInnerHTML={{ __html: product.description }}
                />
              </div>
              <div className="tab-pane fade" id="shipping" role="tabpanel">
                <p>
                  You can avail free shipping on orders above Rs. 6000. Returns
                  accepted within 7 days of delivery.
                </p>
              </div>
              <div className="tab-pane fade" id="delivery" role="tabpanel">
                <p>
                  Orders are delivered across Pakistan within 3–5 working days.
                  No deliveries on Sundays or public holidays.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
